import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  FETCH_LESSON_PLANS,
  FETCH_LESSON_PLANS_FAIL,
  FETCH_LESSON_PLANS_SUCCESS,
  FetchLessonPlansAction
} from '../redux/lessonPlansReducer'
import { LessonPlan } from '../types'

function* FetchLessonFlow(action: FetchLessonPlansAction): Generator<any, void, any> {
  try {
    const response: LessonPlan[] = yield call(apiCall, {
      endpoint: `/tutors/units/${action.payload.unitId}/lesson_plans`,
      method: 'GET',
      params: {}
    })
    yield put(FETCH_LESSON_PLANS_SUCCESS({ lessonPlans: response, unitId: action.payload.unitId }))
  } catch (error) {
    yield put(FETCH_LESSON_PLANS_FAIL())
    console.log(error)
  }
}

export default function* FetchLessonPlans(): Generator<any, void, any> {
  yield takeLatest([FETCH_LESSON_PLANS], FetchLessonFlow)
}
